import { render, staticRenderFns } from "./v-chat-print-timestamp.vue?vue&type=template&id=a840d486&scoped=true&"
var script = {}
import style0 from "./v-chat-print-timestamp.vue?vue&type=style&index=0&id=a840d486&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a840d486",
  null
  
)

export default component.exports